// extracted by mini-css-extract-plugin
module.exports = {"secondaryNav":"styles_secondaryNav__tM8cT","badge":"styles_badge__2tf3_"};